module.exports = __webpack_public_path__ + "img/hr-pump-south.4ed7ef18.png";